import * as actionTypes from "./ActionTypes"
// import { API } from "services/API"
import { APIGet, APIPost } from "services/APIRequest"
import UrlServer from "configs/UrlServer"

export const listsEmailHotAlertUpdate = () => {
  return dispatch => {

    APIPost(UrlServer.URL_POST_EMAILHOTALERT_FROM_IMPORT_GET,{}, datas => {
      dispatch({ type: actionTypes.LISTS_EMAIL_HOTALERT_UPDATE, listsEmailHotAlert: datas.datas })
    })
  }
}
